// @flow
// ----------------------------------------
// Notifications
// ----------------------------------------
export var OLD_NOTIFICATIONS = '[notifications] OLD_NOTIFICATIONS';
export var NEW_NOTIFICATIONS = '[notifications] NEW_NOTIFICATIONS';
export var OPEN_NOTIFICAIONS = '[notifications] OPEN_NOTIFICAIONS';
export var CLOSE_NOTIFICAIONS = '[notifications] CLOSE_NOTIFICAIONS';
export var RESET_NOTIFICATIONS = '[notifications] RESET_NOTIFICATIONS';
export var STORE_NEW_DATA = '[notifications] STORE_NEW_DATA';
export var TOGGLE_NOTIFICATION_COUNT = '[notifications] TOGGLE_NOTIFICATION_COUNT';
export var FETCH_LODGES = 'FETCH_LODGES'; // ----------------------------------------
// TrekLists
// ----------------------------------------

export var STORE_TREKS = '[treks] store';
export var REQUEST_TREKS = '[treks] fetch_available_treks';
export var REQUEST_MY_TREKS = '[treks] fetch_user_treks';
export var FILTER_TREK_BY_SEARCH_TERM = '[filter] search_term';
export var FILTER_TREK_BY_DAYS = '[filter] days';
export var FILTER_TREK_BY_STARS = '[filter] stars';
export var FILTER_TREK_BY_PRICE = '[filter] price';
export var CLEAR_FILTERS = '[filter] clear';
export var GET_TREK_DETAILS = 'GET_TREK_DETAILS';
export var SET_NEW_TREK_DETAILS = 'SET_NEW_TREK_DETAILS';
export var NEW_COMMENT = 'NEW_COMMENT';
export var INCREMENT_LIKES = 'INCREMENT_LIKES';
export var ADD_CHILD = 'ADD_CHILD';
export var REMOVE_CHILD = 'REMOVE_CHILD';
export var CREATE_NODE = 'CREATE_NODE';
export var DELETE_NODE = 'DELETE_NODE';
export var ADD_ENTITIES = 'ADD_ENTITIES'; // ----------------------------------------
// Reviews
// ----------------------------------------

export var ADD_NEW_REVIEW = 'ADD_NEW_REVIEW'; // ----------------------------------------
// UI Section
// ----------------------------------------

export var SET_TREK_REVIEW_IDS = 'SET_TREK_REVIEW_IDS';
export var ADD_ITEMS = 'ADD_ITEMS';
export var REMOVE_ITEMS = 'REMOVE_ITEMS';
export var REMOVE_LAST_ITEM = 'REMOVE_LAST_ITEM';
export var CLEAR_ALL_ITEMS = 'CLEAR_ALL_ITEMS'; // ----------------------------------------
// Flights
// ----------------------------------------

export var FLIGHTQUERY_INIT = '[flight] FLIGHTQUERY_INIT';
export var FLIGHTQUERY_UPDATE = '[flight] FLIGHTQUERY_UPDATE';
export var FLIGHT_SEARCH_RESULTS_INIT = '[flight] FLIGHT_SEARCH_RESULTS_INIT';
export var PICK_FLIGHT = '[flight] PICK_FLIGHT';
export var CLEAR_PICKED_FLIGHT = '[flight] CLEAR_PICKED_FLIGHTS';
export var UPDATE_TIMER = '[ flight ] UPDATE_TIMER';
export var SEARCH_PARAMS_INIT = '[flight] SEARCH_PARAMS_INIT';
export var SEARCH_PARAMS_UPDATE = '[flight] SEARCH_PARAMS_UPDATE';
export var SEARCH_RESULTS_INIT = '[flight] SEARCH_RESULTS_INIT';
export var CHANGE_FLIGHT_SORTER = '[flight] CHANGE_FLIGHT_SORTER';
export var FLIGHT_SEARCH_FAILED = '[flight] FLIGHT_SEARCH_FAILED';
export var SELECT_A_FLIGHT = '[flight] SELECT_A_FLIGHT';
export var CLEAR_SELECTED_FLIGHT = '[flight] CLEAR_SELECTED_FLIGHT';
export var START_FLIGHT_SEARCH = '[ flight ] START_FLIGHT_SEARCH';
export var ENTER_FLIGHT_BOOKING_STAGE = '[flight] ENTER_FLIGHT_BOOKING_STAGE';
export var INIT_PASSENGER_DETAILS = '[ flight ] INIT_PASSENGER_DETAILS';
export var UPDATE_PASSENGER_DETAIL = '[ flight ] UPDATE_PASSENGER_DETAIL';
export var STORE_CONTACT_DETAILS = '[ flight ] STORE_CONTACT_DETAILS';
export var STORE_RESERVATION_DETAILS = '[ flight ] STORE_RESERVATION_DETAILS';
export var ENTER_REVIEW_STAGE = '[ flight ] ENTER_REVIEW_STAGE';
export var EXIT_REVIEW_STAGE = '[ flight ] EXIT_REVIEW_STAGE'; // export const STORE_FLIGHT_BOOKING_ID = '[ flight ] STORE_FLIGHT_BOOKING_ID';
// export const STORE_PROCESS_ID = '[ flight ] STORE_PROCESS_ID';
// export const STORE_FLIGHTS_BOOKING_PROCESS_ID =
// '[ flight ] STORE_FLIGHTS_BOOKING_PROCESS_ID';

export var STORE_SEARCH_QUERY_ERRORS = '[ flights ] STORE_SEARCH_QUERY_ERRORS';
export var UPDATE_PASSENGER_DETAILS = '[ flights ] UPDATE_PASSENGER_DETAILS';
export var RESET_FLIGHTS_UI = '[flights] RESET_FLIGHTS_UI';
export var FLIGHT_BOOKING_SUCCESS = '[ flights analytics] FLIGHT_BOOKING_SUCCESS';
export var CHANGE_TREK_PAYMENT_NUMBER_OF_PEOPLE = '[flights] CHANGE_TREK_PAYMENT_NUMBER_OF_PEOPLE';
export var SHOW_RESERVATION_FAILED_MESSAGE = '[ flights ] SHOW_RESERVATION_FAILED_MESSAGE';
export var STORE_FLIGHTS_PAYMENT_DETATILS = '[flights] store invoices related to flights';
export var BOOK_SELECTED_FLIGHTS = '[flights] clear old flights reservation and payment details'; // ----------------------------------------
// Authorization
// ----------------------------------------

export var LOGOUT = '[auth] logout';
export var REQUEST_LOGIN = '[auth] login';
export var STORE_TOKEN = '[auth] store_token';
export var REGISTER_ACCOUNT = '[auth] register';
export var INIT_USER_INFO = '[auth] init_user_info';
export var CLEAR_ALL_ERRORS = '[auth] clear_errors';
export var STORE_ERROR = '[auth] report_server_errors';
export var STORE_USER_INFORMATION = '[auth] save_user_info';
export var LOGIN_SESSION_EXPIRE = '[auth] expire_login_session';
export var RESET_USER_DATA = '[auth] clear_user_data';
export var SIGNEDUP_SUCCESS = '[auth] sending data to google analytics'; // ----------------------------------------
// Invoices also stored in user state
// ----------------------------------------

export var FETCH_INVOICES = '[profile] FETCH_INVOICES';
export var STORE_INVOICES = '[profile] STORE_INVOICES';
export var IS_FETCHING_USER = '[user] IS_FETCHING_USER';
export var UPDATE_USER_DATA = '[user] UPDATE_USER_DATA'; // OVERIEW_EDIT_MODAL--OVERVIEW_EDITOR

export var TOGGLE_EDITOR = '[editor] TOGGLE_EDITOR';
export var ACTIVATE_A_EDITOR = '[editor] ACTIVATE_A_EDITOR';
export var SET_SCREEN_SIZE = '[editor] SET_SCREEN_SIZE';
export var SET_EDITOR_TYPE = '[editor] SET_EDITOR_TYPE'; // ----------------------------------------
// TREK OVERVIEW
// ----------------------------------------

export var OPEN_OVERVIEW_MODAL = '[overview] OPEN_OVERVIEW_MODAL';
export var OPEN_NESTED_OVERVIEW_MODAL = '[overview] OPEN_NESTED_OVERVIEW_MODAL';
export var CLOSE_NESTED_OVERVIEW_MODAL = '[overview] CLOSE_NESTED_OVERVIEW_MODAL';
export var CLOSE_OVERVIEW_MODAL = '[overview] CLOSE_OVERVIEW_MODAL';
export var SET_ACTIVE_EDITOR = '[overview] SET_ACTIVE_EDITOR';
export var CLOSE_EDITOR = '[overview] CLOSE_EDITOR';
export var PATCH_OVERVIEW_EDITS = '[selectedTrek] PATCH_OVERVIEW_EDITS';
export var UPDATE_OVERVIEW_EDITS = '[selectedTrek] UPDATE_OVERVIEW_EDITS';
export var FOLLOW_TREK = '[trek overview] FOLLOW_TREK';
export var STORE_TREK_PREFERENCES = '[trek overview] STORE_TREK_PREFERENCES';
export var UPDATE_TREK_PREFERENCES = '[trek overview] UPDATE_TREK_PREFERENCES';
export var USE_TREK_AS_TEMPLATE_SUCCESS = '[selectedTrek] USE_TREK_AS_TEMPLATE_SUCCESS';
export var STORE_TREK_BOOKING_STATUS = '[ trekPayment ] STORE_TREK_BOOKING_STATUS';
export var RESET_SELECTED_TREK = '[Selected Trek] RESET_SELECTED_TREK'; // SERVICES MODAL

export var DEFINE_CURRENT_PLACE = 'DEFINE_CURRENT_PLACE';
export var RESET_CURRENT_PLACE = 'RESET_CURRENT_PLACE';
export var SELECT_SERVICETYPE = 'SELECT_SERVICETYPE';
export var RESET_SERVICETYPE = 'RESET_SERVICETYPE';
export var REQUEST_SERVICES_CARDS = 'REQUEST_SERVICES_CARDS';
export var STORE_SERVICES_CARDS = 'STORE_SERVICES_CARDS'; // export const FILTER_CARD_BY_SEARCH_TERM = 'FILTER_CARD_BY_SEARCH_TERM';

export var FILTER_CARD_BY_SERVICES = 'FILTER_CARD_BY_SERVICES';
export var FILTER_CARD_BY_ALTITUDE = 'FILTER_CARD_BY_ALTITUDE';
export var FILTER_CARD_BY_CATEGORY = 'FILTER_CARD_BY_CATEGORY';
export var CLEAR_SERVICE_FILTERS = 'CLEAR_SERVICE_FILTERS';
export var SELECT_CURRENT_THEME_ID = 'SELECT_CURRENT_THEME_ID';
export var RESET_CURRENT_THEME_ID = 'RESET_CURRENT_THEME_ID';
export var ADD_DETAIL_TO_CARD = 'ADD_DETAIL_TO_CARD';
export var SET_CURRENT_PAGENO = 'SET_CURRENT_PAGENO';
export var TOGGLE_LOADMORE = 'TOGGLE_LOADMORE';
export var SELECT_SERVICE_TYPE = 'SELECT_SERVICE_TYPE';
export var OPEN_SERVICES_MODAL = 'OPEN_SERVICES_MODAL';
export var CLOSE_SERVICES_MODAL = 'CLOSE_SERVICES_MODAL';
export var SET_MODAL_CONFIG = 'SET_MODAL_CONFIG';
export var CLEAR_MODAL_CONFIG = 'CLEAR_MODAL_CONFIG';
export var CHANGE_MODAL_CONFIG = 'CHANGE_MODAL_CONFIG';
export var SET_CARD_LOADING_STATE = 'SET_CARD_LOADING_STATE';
export var OPEN_DAY_EDIT_NOTIFICATION_MODAL = 'OPEN_DAY_EDIT_NOTIFICATION_MODAL';
export var CLOSE_DAY_EDIT_NOTIFICATION_MODAL = 'CLOSE_DAY_EDIT_NOTIFICATION_MODAL';
export var SET_NOTIFICATION_TYPE = 'SET_NOTIFICATION_TYPE'; // STORE TREKS BY IDS

export var STORE_TREKS_BY_IDS = 'STORE_TREKS_BY_IDS'; // SCHERMA

export var SCHEMA_INIT = '[schema] init';
export var SCHEMA_ADD = '[schema] add';
export var SCHEMA_REMOVE = '[schema] remove';
export var SCHEMA_UPDATE = '[schema] update';
export var SCHEMA_ADD_BATCH = '[schema add batch]';
export var SCHEMA_REMOVE_BATCH = '[schema remove batch]';
export var SCHEMA_REMOVE_PLACES_THEMES = '[schema remove batch places]'; // SELECTED TREK

export var GET_SELECTED_TREK_BY_NAME = '[selectedTrek] GET_SELECTED_TREK_BY_NAME';
export var STORE_SELECTED_TREK = '[selectedTrek] STORE_SELECTED_TREK'; // ADD CARD TO DAY

export var ADD_CARD_TO_DAY = 'ADD_CARD_TO_DAY'; // GET DAY DATA

export var GET_DAY_DATA = 'GET_DAY_DATA'; // MY TREKS

export var FETCH_MY_TREKS = 'FETCH_MY_TREKS'; // Buy trek

export var SET_BUY_STAGE = '[buy trek] SET_BUY_STAGE'; // PLACE PAGE

export var FETCH_PLACE_BY_PLACE_ID = '[ place ] FETCH_PLACE_BY_PLACE_ID';
export var STORE_PLACE_BY_PLACE_ID = '[ place ] STORE_PLACE_BY_PLACE_ID';
export var SET_SELECTED_PLACE_ID = '[selectedPlace] SET_SELECTED_PLACE_ID'; // pLACES MODAL

export var TOGGLE_PLACES_MODAL = '[ placesModal TOGGLE_PLACES_MODAL]';
export var OPEN_PLACES_MODAL = '[placesModal] OPEN_PLACES_MODAL';
export var CLOSE_PLACES_MODAL = '[placesModal] CLOSE_PLACES_MODAL';
export var CHANGE_SLIDE = '[placesModal] CHANGE_SLIDE'; // PLACES THEME SORTERS

export var SET_SORT_METHOD = '[ selectedPlace ] SET_SORT_METHOD';
export var SET_LIMIT_AND_PAGE = '[selectedPlace] SET_LIMIT_AND_PAGE';
export var SET_THEME_CATEGORIES = '[selectedPlace] SET_THEME_CATEGORIES';
export var SET_LAST_PAGE = '[selectedPlace] SET_LAST_PAGE';
export var CLEAR_THEME_CONFIGS = '[selectedPlace] CLEAR_THEME_CONFIGS'; // PLACES SEARCH

export var FILTER_CARD_BY_SEARCH_TERM = 'FILTER_CARD_BY_SEARCH_TERM'; // MODAL

export var OPEN_LOGIN_MODAL = '[auth] open_login_modal';
export var OPEN_SIGNUP_MODAL = '[auth] open_signup_modal';
export var CLOSE_LOGIN_MODAL = '[auth] close_login_modal'; // EDIT MODAL

export var OPEN_MODAL = '[modal] open_modal';
export var CLOSE_MODAL = '[modal] close_modal'; // ----------------------------------------
// Lodge Details
// ----------------------------------------

export var SUCCESS = '[lodge] success';
export var FAILURE = '[lodge] failure';
export var SET_DATE = '[lodge] set_date';
export var BOOK_LODGE = '[lodge] book';
export var LODGE_ADDED = '[lodge] added';
export var ADD_TO_TREK = '[lodge] add_to_trek';
export var INCREMENT_PAX = '[lodge] increment pax';
export var DECREMENT_PAX = '[lodge] decrement pax';
export var RESET_SUCCESS = '[lodge] reset_success';
export var SELECT_ROOM_TYPE = '[lodge] select_room';
export var STORE_LODGE_DETAILS = '[lodge] store';
export var UPDATE_LODGE_DETAILS = '[lodge] update lodge details';
export var CHANGE_PAYMENT_TYPE = '[lodge] change_payment_type';
export var REQUEST_LODGE_DETAILS = '[lodge] fetch'; // ----------------------------------------
// Trek Payment Review
// ----------------------------------------

export var STORE_TREK_PAYMENT_DETAILS = '[trekPayment] STORE_TREK_PAYMENT_DETAILS';
export var CHANGE_TREK_PAYMENT_TYPE = '[trekPayment] CHANGE_TREK_PAYMENT_TYPE';
export var TREK_PAYMENT_SUCCESS = '[trekPayment] TREK_PAYMENT_SUCCESS';
export var CONTIUE_TO_BUY_TREK_TEMPLATE = '[ trekPayment ] CONTIUE_TO_BUY_TREK_TEMPLATE';
export var CHANGE_TREK_TEMPLATE_START_DATE = '[trekPayment] CHANGE_TREK_TEMPLATE_START_DATE';
export var CREATE_TREK_FROM_TREK_REVIEW = '[ trekPayment] CREATE_TREK_FROM_TREK_REVIEW';
export var UPDATE_CREATED_TREK = '[ trekPayment ] UPDATE_CREATED_TREK';
export var GET_TREK_BOOKING_ID = '[ trekPayment ] GET_TREK_BOOKING_ID';
export var STORE_TREK_BOOKING_ID = '[ trekPayment ] STORE_TREK_BOOKING_ID';
export var TRACK_TREK_PAYMENT_REVIEW_PAGEVIEW = '[ trekPayment analytics ] TRACK_TREK_PAYMENT_REVIEW_PAGEVIEW';
export var SET_TREK_PAYMENT_LOADING_STATE = '[ trekPayment ] SET_TREK_PAYMENT_LOADING_STATE';
export var PROCEED_TO_TREK_PAYMENT = '[trekPayment] get invoice for lodges in the trek and redirect to trek paymnent';
export var CONTINUE_TO_BUY_GUIDED_TREK = '[ trekPayment ] get invoice id for guided trek and navigate to trek payment page'; // ----------------------------------------
// Lodges Payment Review
// ----------------------------------------

export var LODGE_BOOKING_REQUEST_SUCCESS = '[lodge] LODGE_BOOKING_REQUEST_SUCCESS'; // ----------------------------------------
// LIGHTBOX STATE
// ----------------------------------------

export var OPEN_LIGHTBOX = '[lightboxState] OPEN_LIGHTBOX';
export var CLOSE_LIGHTBOX = '[lightboxState] CLOSE_LIGHTBOX'; // SELECTED REGION

export var CHANGE_SELECTED_REGION = '[selectedRegion] CHANGE_SELECTED_REGION'; // ----------------------------------------
// REVIEWS
// ----------------------------------------

export var ADD_REPLY = '[reviews] add reply';
export var ADD_REVIEW = '[reviews] add review';
export var FETCH_REVIEWS = '[reviews] fetch reviews';
export var DELETE_REPLY = '[reviews] delete reply';
export var DELETE_REVIEW = '[reviews] delete review';
export var STORE_REVIEWS = '[reviews] store reviews';
export var RESET_REVIEWS = '[reviews] reset reviews';
export var UPDATE_REPLY = '[reviews] update reply';
export var UPDATE_REVIEW = '[reviews] update review';
export var UPDATED = '[reviews] updated'; // ----------------------------------------
// RATINGS
// ----------------------------------------

export var SEND_RATINGS = '[ratings] send ratings';
export var FETCH_RATINGS = '[ratings] fetch ratings';
export var STORE_RATINGS = '[ratings] store ratings';
export var RESET_RATINGS = '[ratings] reset ratings'; // ANALYTICS EVENT ACTION TYPES
// ----------------------------------------

export var SET_USER_ID = '[ analytics event ]  SET_USER_ID';
export var ON_EMAIL_SUBSCRIPTION = '[ analytics event ] User Subscribed To Mailing List';
export var ON_FLIGHTS_SEARCH = '[ analytics event ] Track Search Params For adwords remarketing';
export var CLICKED_ON_REQUEST_PORTER_GUIDE = '[ analytics event ] Track Clicks on Request Porter Guide Button';
export var CLICKED_ON_VIEW_GUIDE_PORFILE = '[ analytics event ] Track Clicks on View Guide Profile Button';
export var CLICKED_ON_REQUEST_GUIDE = '[ analytics events ] Track Clicks on Request Guide Button';
export var PORTER_GUIDE_PAYMENT_SUCCESS = '[ analytics events ] Porter Guide Payment Success';
export var GUIDE_PAYMENT_SUCCESS = '[ analytics events ] Guide Payment Success'; // ADMIN ACTION

export var MASQUERADE_USER = '[ admin ] super user masquerade as another user';